module.exports = __webpack_public_path__ + "img/羽球.9dfc4f3c.jpg";